<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <RouteForm :baseRoute="route" :baserouteName="name" :loading="loading" @submit-requested="submitRequested"></RouteForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import RouteForm from './RouteForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                route: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { RouteForm },
        computed:
        {
            ...mapState('routes', ['getRouteByIdOutput']),
        },
        methods: {
            ...mapActions('routes', ['getRouteById']),
            ...mapActions('routes', ['putRoute']),
            submitRequested(route) {
                this.putRoute(route);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({ name: 'Routes'});
            }
            else {
                this.getRouteById(this.$route.query.id);
            }
        },
        watch:
        {
            getRouteByIdOutput: function (output) {
                if (!output) {
                    router.push({ name: 'Routes'});
                }
                else {
                    this.route = output;
                    this.loading = false;
                }
            }
        }
    }
</script>